<template>
  <div class="pneu-borracha ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="1">
          <br />
          <b-button
            variant="warning"
            class="ml-5 mt-2"
            v-b-modal.modal-multi-borracha
            @click="reset()"
            >Novo</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3"></div>
    <!--tbl de dados -->
    <b-table
      id="borracha"
      small
      hover
      striped
      sticky-header="818px"
      :items="borrachas"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="editborracha(data.item)"
          title="Editar borracha"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-borracha
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL GRAVAÇÃO RELACAO DA borracha pneu -->
    <!--  MODAL GRAVAÇÃO RELACAO DA borracha pneu -->
    <div>
      <b-modal
        id="modal-multi-borracha"
        hide-footer
        size="lg"
        title="Cadastro de borrachas"
      >
        <!-- -->
        <div>
          <b-row>
            <b-col cols="6">
              <label for="input-filial">Empresa</label>
              <div>
                <b-form-select
                  id="fun-empresa"
                  v-model="bor.empresa_id"
                  required
                  :options="empresas"
                  class="mb-3"
                  text-field="empresa"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="6">
              <label for="input-live">borracha</label>
              <b-form-input
                v-model="bor.borracha"
                placeholder="Digite a descrição do borracha"
              ></b-form-input>
            </b-col>
          </b-row>
          <input id="id-borracha" type="hidden" v-model="bor.id" />

          <b-button class="mt-3" variant="success" block @click="postborracha()"
            >Gravar</b-button
          >
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";

export default {
  computed: { ...mapState(["user"]) },
  name: "Manutencaoborracha",

  data: function () {
    return {
      carregando: false,
      empresas: [],
      bor: {}, // [] lista
      borrachas: [],

      //  barra_inicial: 0,
      //  barra_limite: 300000,

      fields: [
        { key: "empresa_id", label: "Empresa", sortable: true },
        { key: "id", label: "Id", sortable: true },
        { key: "borracha", label: "borracha", sortable: true },
        {
          key: "dt_cadastro",
          label: "Data Cadastro",
          sortable: true,
          formatter: (value, key, borrachas) => {
            return moment(borrachas.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_alteracao",
          label: "Data Alteracao",
          sortable: true,
          formatter: (value, key, borrachas) => {
            return moment(borrachas.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {},
  methods: {
    loadEmpresa() {
      let params = {
        psg: this.user.psg,
        id_grupo_empresa: `${this.user.id_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadborracha() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/borracha`;
      axios.get(url, { params }).then((res) => {
        this.borrachas = res.data.map((bor) => {
          return { ...bor };
        });
      });
    },

    editborracha(bor) {
      this.bor = { ...bor };
      this.loadEmpresa();
    },

    postborracha() {
      let corpo = {
        psg: this.user.psg,
        empresa_id: `${this.bor.empresa_id}`,
        id_funcionario: `${this.user.id_funcionario}`,
        id: `${this.bor.id}`,
        borracha: `${this.bor.borracha}`,
      };

      const url = `${baseApiUrl}/pneu/borrachacad`;

      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.reset(); //limpar os objetos valores
        })
        .catch(showError);
    },

    reset() {
      this.grup = {};
      this.loadborracha();
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadborracha(); //    se habilitado carrega o grid
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.7em;
}

#borrachas {
  font-size: 0.9em;
  text-align: center;
}
</style>